import { ApiError, normalizeApiError } from '../../services/apiError';

/** The 402 detail trigger-agents sends when a design run cannot be paid for (worded in the user's language). */
export interface PlanningCreditRefusalDetail {
  code: 'planning_out_of_credits';
  message: string;
  add_credits?: boolean;
  upgrade_available?: boolean;
  shortfall?: number;
}

/** Thrown in place of a generic trigger failure so the start flow shows the refusal in chat, not a toast. */
export const PLANNING_CREDIT_REFUSED = 'PLANNING_CREDIT_REFUSED';

export const planningCreditRefusalFrom = (error: unknown): PlanningCreditRefusalDetail | null => {
  const normalized = normalizeApiError(error);
  const detail = normalized.detail as Partial<PlanningCreditRefusalDetail> | undefined;

  if (normalized.status !== 402 || !detail || detail.code !== 'planning_out_of_credits') return null;
  if (typeof detail.message !== 'string' || !detail.message.trim()) return null;

  return detail as PlanningCreditRefusalDetail;
};

export const isPlanningCreditRefused = (error: unknown): boolean => (
  error instanceof ApiError && error.code === PLANNING_CREDIT_REFUSED
);

/** Show a credit refusal through ``show`` and rethrow it as one the start flow does not toast. */
export const throwIfPlanningCreditRefused = (
  error: unknown, show: (refusal: PlanningCreditRefusalDetail) => void,
): void => {
  const refusal = planningCreditRefusalFrom(error);

  if (!refusal) return;
  show(refusal);
  throw new ApiError({ code: PLANNING_CREDIT_REFUSED, message: refusal.message, status: 402, detail: refusal });
};
